import {
  Badge,
  Box,
  Flex,
  HStack,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { creatorScore } from "../../api";

export default function ViewScoreModal({ isOpen, onClose, profileId }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen || !profileId) return;
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, profileId]);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await creatorScore({ profileId });
      setData(res);
    } catch (e) {
      console.error(e);
      setError("페르소나 정보를 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent maxH="85vh" mx={{ base: "12px", md: 0 }}>
        <ModalHeader>스코어 상세</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="24px" overflowY="auto">
          {loading && <Text>로딩중...</Text>}
          {error && <Text color="red.500">{error}</Text>}

          {data?.data?.map((item) => (
            <Box key={item.socialId}>
              {/* 채널 정보 */}
              <Flex
                justify="space-between"
                align="center"
                mb="16px"
                p="12px"
                bg="gray.50"
                borderRadius="12px"
              >
                <HStack spacing="10px">
                  <Badge colorScheme="purple">{item.platform}</Badge>
                  <Text fontWeight={700}>@{item.username}</Text>
                </HStack>

                <Link
                  href={item.channelUrl}
                  isExternal
                  color="blue.500"
                  fontSize="14px"
                >
                  채널 방문 ↗
                </Link>
              </Flex>

              {/* 종합 점수 */}
              <Box
                textAlign="center"
                p="20px"
                bg="blue.50"
                borderRadius="16px"
                mb="20px"
              >
                <Text fontSize="14px" color="gray.600">
                  종합 스코어
                </Text>
                <Text fontSize="48px" fontWeight={800} color="blue.600">
                  {item.compositeScore}
                </Text>
              </Box>

              {/* 세부 점수 */}
              <SimpleGrid columns={2} spacing="12px" mb="20px">
                <ScoreCard label="활성 점수" value={item.activityScore} />
                <ScoreCard label="관계성 점수" value={item.engagementScore} />
                <ScoreCard label="성장성 점수" value={item.growthScore} />
                <ScoreCard
                  label="팔로워 비율 점수"
                  value={item.followerRatioScore}
                />
              </SimpleGrid>

              {/* 메타 정보 */}
              <Box
                p="12px"
                border="1px solid #E2E8F0"
                borderRadius="12px"
                fontSize="13px"
                color="gray.600"
              >
                <VStack align="start" spacing="4px">
                  <Text>
                    시나리오 타입: <b>{item.scenarioType}</b>
                  </Text>
                  <Text>
                    계산일: {new Date(item.calculatedAt).toLocaleString()}
                  </Text>
                  <Text>
                    성장성 반영: {item.growthIncluded ? "포함" : "미포함"}
                  </Text>
                  <Text>
                    팔로워 비율 반영:{" "}
                    {item.followerRatioIncluded ? "포함" : "미포함"}
                  </Text>
                </VStack>
              </Box>
            </Box>
          ))}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function ScoreCard({ label, value }) {
  return (
    <Box
      p="14px"
      border="1px solid #E2E8F0"
      borderRadius="12px"
      textAlign="center"
      bg="white"
    >
      <Text fontSize="13px" color="gray.500">
        {label}
      </Text>
      <Text fontSize="24px" fontWeight={700} color="gray.800">
        {value}
      </Text>
    </Box>
  );
}
